module.exports = __webpack_public_path__ + "static/media/screenshot-1.ca4e8273.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-1.png
// module id = 686
// module chunks = 2